import React from 'react';
import LazyImage from '../atoms/LazyImage';
import { getResponsiveImage } from '../../utils/responsiveImage';

/** LazyImage wired to WD-06 derivative manifest by original public path. */
const ResponsiveLazyImage = ({ originalSrc, src, ...props }) => {
  const sourcePath = originalSrc || src;
  const responsive = getResponsiveImage(sourcePath);

  return (
    <LazyImage
      src={responsive.src}
      srcSet={responsive.srcSet}
      sizes={responsive.sizes}
      {...props}
    />
  );
};

export default ResponsiveLazyImage;
